import React, { useState, useEffect, useMemo } from "react";
import {
  Popconfirm,
  Button,
  Table,
  Tag,
  Alert,
  Modal,
  Input,
  Col,
  notification,
  Pagination,
  Row,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import $axios from "../../services/axios";

const YourComponent = () => {
  const [cookieFacebook, setCookieFacebook] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [newProxy, setNewProxy] = useState("");
  const [listCookie, setListCookie] = useState([]);
  const [loadingProxyChange, setLoadingProxyChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pager, setPager] = useState(1);
  const [countTotal, setCountTotal] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [chosenId, setChosenId] = useState("");
  const [pageSize, setPageSize] = useState(20);

  const columns = [
    // {
    //   title: "Time",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   align: "center",
    //   fixed: "left",
    //   render: (text, record) => (
    //     <Tag color="primary" closable={false} effect="plain" size="large">
    //       {ConvertDateTime(record.createdAt)}
    //     </Tag>
    //   ),
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      fixed: "left",
      render: (text, record) => (
        <a
          href={`https://facebook.com/${record.uid}`}
          target="_blank"
          className="text-primary"
          style={{ textDecoration: "none" }}
          rel="noreferrer"
        >
          {record.name}
        </a>
      ),
    },
    {
      title: "UID",
      dataIndex: "uid",
      key: "uid",
      align: "center",
      fixed: "left",
      render: (text, record) => (
        <a
          href={`https://www.facebook.com/${record.uid}`}
          target="_blank"
          className="text-primary"
          style={{ textDecoration: "none" }}
          rel="noreferrer"
        >
          {record.uid}
        </a>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",

      align: "center",

      render: (text) => (
        <Tag color={text == "Live" ? "green" : "red"}>{text}</Tag>
      ),
    },
    {
      title: "Proxy",
      dataIndex: "proxy",
      key: "proxy",
      align: "center",
      fixed: "left",
      render: (text, record) => (
        <span>
          <Tag
            className="new-cursor"
            type="warning"
            onClick={() => handleChangeProxy(record)}
            closable={false}
            effect="plain"
            size="large"
            disable-transitions={true}
          >
            {record.proxy}
          </Tag>
        </span>
      ),
    },
  ];

  const ConvertDateTime = (unixtime) => {
    let time = new Date(unixtime);
    let date = time.getDate();
    let month = time.getMonth() + 1;
    let year = time.getFullYear();
    return date + "/" + month + "/" + year;
  };

  useEffect(() => {
    LoadToken();
  }, [pager, pageSize]);

  const LoadToken = async () => {
    setLoading(true);
    try {
      const data = await $axios.get(
        `/facebook?offset=${(pager - 1) * 10}&limit=10`,
      );
      setListCookie(data.data.data.data);
      setCountTotal(data.data.data.total);
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description: "Có lỗi xảy ra",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFacebook = () => {
    setLoading(true);
    selectedRowKeys.forEach(async (row) => {
      try {
        let data = await $axios.delete(`/facebook/${row}`);
        notification.success({
          message: "Thành công",
          description: "Xoá Facebook thành công",
        });
      } catch (error) {
        notification.error({
          message: "Thất bại",
          description: "Có lỗi xảy ra",
        });
      } finally {
        LoadToken();
        setSelectedRowKeys([]);
      }
    });
  };

  const handleChangeProxy = (record) => {
    setNewProxy("");
    setChosenId(record.id);
    setModalVisible(true);
  };

  const handleProxyChange = async () => {
    setLoadingProxyChange(true);
    try {
      let data = await $axios.patch(
        `/facebook/${chosenId}/change-proxy?proxy=${newProxy}`,
      );

      notification.success({
        message: "Thành công",
        description: "Cập nhật thành công",
      });
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description: "Có lỗi xảy ra",
      });
    } finally {
      LoadToken();
      setLoadingProxyChange(false);
    }

    setModalVisible(false);
  };

  const AddFacebook = async () => {
    setLoading(true);
    const cookies = cookieFacebook.split("\n");

    cookies.forEach(async (cookie) => {
      const proxy = cookie.split("|");
      try {
        let data = await $axios.post("/facebook", {
          cookie: proxy[0],
          secret: proxy[1],
          proxy: proxy[2],
        });

        notification.success({
          message: "Thành công",
          description: "Thêm mới thành công",
        });
      } catch (error) {
        notification.error({
          message: "Thất bại",
          description: "Có lỗi xảy ra",
        });
      } finally {
        setCookieFacebook("");
        LoadToken();
      }
    });
  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = useMemo(() => {
    return selectedRowKeys.length > 0;
  }, [selectedRowKeys]);

  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };
  return (
    <div>
      <Row>
        <Col span={24} offset={0}>
          <Input.TextArea
            spellCheck={false}
            rows={4}
            placeholder="cookie|proxy|secret"
            value={cookieFacebook}
            onChange={(e) => setCookieFacebook(e.target.value)}
          />
        </Col>
      </Row>

      <br />

      <Row gutter={20}>
        <Col align="center" span={24} offset={0}>
          <Button type="primary" onClick={AddFacebook} loading={loading}>
            Thêm tài khoản
          </Button>
        </Col>
      </Row>

      <br />

      <Alert
        type="warning"
        description={
          <>
            <b className="text-primary">
              Lưu ý: Cookie chỉ tồn tại liên tục khi bạn duy trì đăng nhập nick
              facebook mà không hề đăng xuất.Cookie có thể hết hạn đột ngột
              trong vòng 24h nếu thực hiện spam.
            </b>

            <p className="text-primary m-0 mt-1 text-12">(Không khuyến nghị)</p>
          </>
        }
        showIcon={false}
        effect="light"
      />

      <br />
      {hasSelected && (
        <Popconfirm
          title="Bạn có chắc chắn?"
          onConfirm={handleRemoveFacebook}
          confirmButtonText="OK"
          cancelButtonText="Không, cảm ơn."
          icon={<i className="el-icon-info" style={{ color: "red" }}></i>}
        >
          <Button
            type="primary"
            className="text-12 mb-2"
            icon={<DeleteOutlined />}
            loading={loading}
            danger
          >
            Xóa {selectedRowKeys.length} FB
          </Button>
        </Popconfirm>
      )}

      <Table
        dataSource={listCookie.map((item) => ({ key: item.id, ...item }))}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        loading={loading}
        pagination={false}
        bordered
        columns={columns}
      />
      <Pagination
        current={pager}
        className="mt-2"
        total={countTotal}
        onChange={(page) => setPager(page)}
        pageSize={pageSize}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
      />

      <Modal
        title="Proxy"
        open={modalVisible}
        onOk={handleProxyChange}
        onCancel={() => setModalVisible(false)}
        confirmLoading={loadingProxyChange}
      >
        <Input
          placeholder="Format: IP:PORT@USERNAME:PASSWORD"
          value={newProxy}
          onChange={(e) => setNewProxy(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default YourComponent;
